export { Hexchess } from './hexchess'
export { index, isPromotionPosition, position, step, walk } from './utils'
export { San } from './san'
export * from './constants'
export * from './types'

export const version = 'x.y.z'
